export const DMS_MODULE = 'OjeteVozy';

export enum SubStringRezEnum {
	FullString = 0,
	Substring = 1,
	SubstringLeft = 2,
	SubstringRight = 3,
	SubstringRightCorrect = 4,
}
